const CaptionType = {
  Insight: "insight",
  Quiz: "quiz",
  Trending: "trending",
  Privacy: "privacy",
  Inspire: "inspire",
  PollOfTheDay: "potd",
};

export default CaptionType;
